export default {
    name: "ToolCertificationChip",
    props: {
        toolCertification: {
            type: Object,
            required: true
        }
    }
};
